import { useAuth } from "../hooks/useAuth";
import { useUsers } from "../hooks/useUsers";
import { useNotifications } from "../hooks/useNotifications";
import "../styles/dashboard.css";

const UserSettings = () => {
  const { isAuthenticated, user } = useAuth();   // ⭐ get user
  const { users, inviteUser, editUser, deleteUser } = useUsers();
  const { success, error } = useNotifications();

  if (!isAuthenticated) {
    return (
      <div className="page-container">
        <h2>Please login first.</h2>
      </div>
    );
  }

  const handleInvite = (e) => {
    e.preventDefault();

    // ⭐ Only main admin can invite users
    if (user?.email !== "admin@example.com") {
      error("Only the main Admin (admin@example.com) can invite users");
      return;
    }

    const form = new FormData(e.target);
    inviteUser({
      name: form.get("name"),
      email: form.get("email"),
      role: form.get("role"),
    });

    success("User invited successfully");
    e.target.reset();
  };

  const toggleRole = (selectedUser) => {
    const newRole = selectedUser.role === "Admin" ? "User" : "Admin";
    editUser(selectedUser.id, { role: newRole });
    success("Role updated");
  };

  const handleDelete = (id) => {
    deleteUser(id);
    success("User removed");
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>User Settings</h1>
      </div>

      {/* 🟢 Only admin@example.com can invite users */}
      {user?.email === "admin@example.com" && (
        <div className="settings-section">
          <h2>Invite User</h2>
          <form onSubmit={handleInvite} className="settings-form">
            <input name="name" placeholder="Name" required />
            <input name="email" placeholder="Email" type="email" required />
            <select name="role">
              <option>User</option>
              <option>Admin</option>
            </select>
            <button type="submit" className="btn-primary">
              Invite
            </button>
          </form>
        </div>
      )}

      <div className="settings-section">
        <h2>Team Members</h2>
        <table className="settings-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              {/* 🟢 Only main admin can take actions */}
              {user?.email === "admin@example.com" && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td>{u.name}</td>
                <td>{u.email}</td>
                <td>{u.role}</td>

                {/* 🟢 Only main admin can manage users */}
                {user?.email === "admin@example.com" && (
                  <td>
                    <button className="btn-small" onClick={() => toggleRole(u)}>
                      Toggle Role
                    </button>
                    <button
                      className="btn-secondary"
                      onClick={() => handleDelete(u.id)}
                    >
                      Remove
                    </button>
                  </td>
                )}
              </tr>
            ))}

            {users.length === 0 && (
              <tr>
                <td colSpan={4}>No users.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserSettings;
